import { render, staticRenderFns } from "./StudentLearningFilesListPage.vue?vue&type=template&id=43b52703&scoped=true"
import script from "./StudentLearningFilesListPage.vue?vue&type=script&lang=js"
export * from "./StudentLearningFilesListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b52703",
  null
  
)

export default component.exports